import { FC, useEffect, useState } from "react";
import { Skeleton, Stack, Box, Typography } from "@mui/material";
import { AIIcon } from "@/assets/icons/app-related/AIIcon";

interface BillingExplorerExplainWithAiLoadingProps {
  variant?: "dark" | "light";
  hideIcon?: boolean;
}
export const ExplainWithAiLoading: FC<
  BillingExplorerExplainWithAiLoadingProps
> = ({ variant, hideIcon }) => {
  const [dots, setDots] = useState("");

  useEffect(() => {
    const dotsTimer = setInterval(() => {
      setDots((prev) => (prev.length < 3 ? prev + "." : ""));
    }, 500);
    return () => clearInterval(dotsTimer);
  }, []);

  return (
    <Stack spacing={1} direction="row" alignItems="center" position="relative">
      {!hideIcon && <AIIcon fontSize="small" />}

      <Box
        position="relative"
        width={220}
        height={40}
        display="flex"
        alignItems="center"
      >
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          sx={{
            bgcolor: variant === "dark" ? "grey.100" : "white",
            borderRadius: 3,
          }}
        />
        <Stack
          direction="row"
          sx={{
            position: "absolute",
            whiteSpace: "nowrap",
          }}
          pl={2}
        >
          <Typography variant="subtitle1">This may take a moment</Typography>
          <Typography variant="subtitle1" minWidth={15}>
            {dots}
          </Typography>
        </Stack>
      </Box>
    </Stack>
  );
};
